import React from 'react';

const PortfolioWalletFormModal = React.lazy(() => import('../components/FormModal'));
const portfolioWalletModalRegistry = {
    personalize_portfolioWalletId: PortfolioWalletFormModal
};
export default portfolioWalletModalRegistry;
